// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lideranca.module.css */
.Lideranca_leadershipSection__yzbBb {
    width: 100%;
    padding: 80px 0 0 0;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
}

.Lideranca_leadershipContent__sXRRW {
    display: flex;
    width: 100%;
    height: 100%;
}

/* Coluna da Imagem */
.Lideranca_leadershipImage__mL21d {
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
}

.Lideranca_leadershipImage__mL21d img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* Coluna do Texto */
.Lideranca_leadershipText__u2ESC {
    flex: 1 1;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-y: auto;
}

.Lideranca_leadershipText__u2ESC h2 {
    font-family: "Space Grotesk", sans-serif;
    font-weight: 700;
    font-size: 3.8rem;
    color: #333;
    line-height: 1.3;
    position: relative;
    padding-bottom: 15px;
}

.Lideranca_leadershipText__u2ESC h2::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 80px;
    height: 4px;
    background-color: #007bff;
    border-radius: 2px;
}

.Lideranca_leadershipDetails__gaLbS {
    margin-top: 30px;
}

.Lideranca_leadershipNames__xmVut h3 {
    font-size: 2rem;
    color: #444;
}

.Lideranca_leadershipNames__xmVut h4 {
    font-size: 1.5rem;
    color: #666;
}

.Lideranca_leadershipText__u2ESC p {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #555;
    text-align: left;
}

/* Responsividade */
@media (max-width: 768px) {
    .Lideranca_leadershipSection__yzbBb {
        padding-top: 60px;
    }

    .Lideranca_leadershipContent__sXRRW {
        flex-direction: column;
    }

    .Lideranca_leadershipImage__mL21d {
        padding: 0;
        /* Remove padding para ocupar largura total */
    }

    .Lideranca_leadershipImage__mL21d img {
        width: 100%;
        height: auto;
        /* Ajusta a altura para manter a proporção */
    }

    .Lideranca_leadershipText__u2ESC {
        padding: 20px;
    }

    .Lideranca_leadershipText__u2ESC h2 {
        font-size: 2rem;
        text-align: center;
    }

    .Lideranca_leadershipText__u2ESC h2::after {
        left: 50%;
        transform: translateX(-50%);
    }

    .Lideranca_leadershipNames__xmVut h3 {
        font-size: 1.6rem;
    }

    .Lideranca_leadershipNames__xmVut h4 {
        font-size: 1.2rem;
    }

    .Lideranca_leadershipText__u2ESC p {
        font-size: 1rem;
    }
}

@media (max-width: 480px) {
    .Lideranca_leadershipSection__yzbBb {
        padding-top: 100px;
    }

    .Lideranca_leadershipImage__mL21d {
        padding: 0;
        /* Remove padding para largura total */
    }

    .Lideranca_leadershipImage__mL21d img {
        width: 100%;
        height: auto;
        /* Mantém proporção da imagem */
    }

    .Lideranca_leadershipText__u2ESC {
        padding: 15px;
    }

    .Lideranca_leadershipText__u2ESC h2 {
        font-size: 1.8rem;
    }

    .Lideranca_leadershipNames__xmVut h3 {
        font-size: 1.4rem;
    }

    .Lideranca_leadershipNames__xmVut h4 {
        font-size: 1.1rem;
    }

    .Lideranca_leadershipText__u2ESC p {
        font-size: 0.95rem;
        line-height: 1.6;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/SobreNos/Lideranca/Lideranca.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qDAAqD;AACzD;;AAEA,oBAAoB;AACpB;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,6CAA6C;IACjD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,4CAA4C;IAChD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,sCAAsC;IAC1C;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,+BAA+B;IACnC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ","sourcesContent":["/* Lideranca.module.css */\r\n.leadershipSection {\r\n    width: 100%;\r\n    padding: 80px 0 0 0;\r\n    background-color: #ffffff;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.leadershipContent {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n/* Coluna da Imagem */\r\n.leadershipImage {\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #ffffff;\r\n}\r\n\r\n.leadershipImage img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n/* Coluna do Texto */\r\n.leadershipText {\r\n    flex: 1;\r\n    padding: 40px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    overflow-y: auto;\r\n}\r\n\r\n.leadershipText h2 {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-weight: 700;\r\n    font-size: 3.8rem;\r\n    color: #333;\r\n    line-height: 1.3;\r\n    position: relative;\r\n    padding-bottom: 15px;\r\n}\r\n\r\n.leadershipText h2::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 0;\r\n    width: 80px;\r\n    height: 4px;\r\n    background-color: #007bff;\r\n    border-radius: 2px;\r\n}\r\n\r\n.leadershipDetails {\r\n    margin-top: 30px;\r\n}\r\n\r\n.leadershipNames h3 {\r\n    font-size: 2rem;\r\n    color: #444;\r\n}\r\n\r\n.leadershipNames h4 {\r\n    font-size: 1.5rem;\r\n    color: #666;\r\n}\r\n\r\n.leadershipText p {\r\n    font-size: 1.1rem;\r\n    line-height: 1.8;\r\n    color: #555;\r\n    text-align: left;\r\n}\r\n\r\n/* Responsividade */\r\n@media (max-width: 768px) {\r\n    .leadershipSection {\r\n        padding-top: 60px;\r\n    }\r\n\r\n    .leadershipContent {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .leadershipImage {\r\n        padding: 0;\r\n        /* Remove padding para ocupar largura total */\r\n    }\r\n\r\n    .leadershipImage img {\r\n        width: 100%;\r\n        height: auto;\r\n        /* Ajusta a altura para manter a proporção */\r\n    }\r\n\r\n    .leadershipText {\r\n        padding: 20px;\r\n    }\r\n\r\n    .leadershipText h2 {\r\n        font-size: 2rem;\r\n        text-align: center;\r\n    }\r\n\r\n    .leadershipText h2::after {\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n    }\r\n\r\n    .leadershipNames h3 {\r\n        font-size: 1.6rem;\r\n    }\r\n\r\n    .leadershipNames h4 {\r\n        font-size: 1.2rem;\r\n    }\r\n\r\n    .leadershipText p {\r\n        font-size: 1rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .leadershipSection {\r\n        padding-top: 100px;\r\n    }\r\n\r\n    .leadershipImage {\r\n        padding: 0;\r\n        /* Remove padding para largura total */\r\n    }\r\n\r\n    .leadershipImage img {\r\n        width: 100%;\r\n        height: auto;\r\n        /* Mantém proporção da imagem */\r\n    }\r\n\r\n    .leadershipText {\r\n        padding: 15px;\r\n    }\r\n\r\n    .leadershipText h2 {\r\n        font-size: 1.8rem;\r\n    }\r\n\r\n    .leadershipNames h3 {\r\n        font-size: 1.4rem;\r\n    }\r\n\r\n    .leadershipNames h4 {\r\n        font-size: 1.1rem;\r\n    }\r\n\r\n    .leadershipText p {\r\n        font-size: 0.95rem;\r\n        line-height: 1.6;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leadershipSection": `Lideranca_leadershipSection__yzbBb`,
	"leadershipContent": `Lideranca_leadershipContent__sXRRW`,
	"leadershipImage": `Lideranca_leadershipImage__mL21d`,
	"leadershipText": `Lideranca_leadershipText__u2ESC`,
	"leadershipDetails": `Lideranca_leadershipDetails__gaLbS`,
	"leadershipNames": `Lideranca_leadershipNames__xmVut`
};
export default ___CSS_LOADER_EXPORT___;
